module.exports = __webpack_public_path__ + "static/About-moringa-hero-100-2159d28cc3fcc1acebb2258a76930014.jpg";